export default function (path, lang) {
  if (lang) return path.replace(`/${lang}`, "")
  else return path
}
